import { render } from "./App.vue?vue&type=template&id=686f2e13"
import script from "./app.view.js?vue&type=script&lang=js&external"
export * from "./app.view.js?vue&type=script&lang=js&external"

import "./app.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__